import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withHandlers, withStateHandlers } from 'recompose'
import { push } from 'react-router-redux'

import InstallJavascript from './component'
import * as OrgActions from 'modules/org/actions'

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    updateOrgProperties: OrgActions.updateOrgProperties,
    push
  }, dispatch)
})

export default compose(
  connect(null, mapDispatchToProps),
  withStateHandlers(() => ({
    inviteModal: false,
    inviteSucceeded: false
  }),
    {
      showInviteModal: ({ inviteModal }) => () => ({
        inviteModal: true,
      }),
      hideInviteModal: ({ inviteModal }) => () => ({
        inviteModal: false,
      }),
      onInvitedSuccess: ({inviteModal, inviteSucceeded}) => () => ({
        inviteModal: false,
        inviteSucceeded: true
      })
    }),
  withHandlers({
    onContinueClick: props => () => {
      props.actions.push('/setup/touchless/install/verify')
    },
    onDashboardClick: props => () => {
      props.actions.updateOrgProperties({ properties: { signUpDone: true }, redirect: true })
    },
  })
)(InstallJavascript)


// WEBPACK FOOTER //
// ./src/layouts/InstallJavascript/index.js